var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgEmptyDocsIcon = function SvgEmptyDocsIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 202,
    viewBox: "-2 -2 75 75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "svg-circle",
    cx: 35.59,
    cy: 35.59,
    r: 35.59
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg-lines",
    points: "42.65 20.52 28.06 20.52 28.06 24.55 22.9 24.55 22.9 50.67 43.13 50.67 43.13 46.64 48.28 46.64 48.28 26.15 42.65 20.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "svg-lines",
    points: "48.28 26.15 42.65 26.15 42.65 20.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "svg-lines",
    points: "28.06 24.55 28.06 46.64 43.13 46.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-symbol",
    d: "M37.09,37l-.48-9.76h3.13L39.25,37Zm0,1.61a1.53,1.53,0,0,1,1.1-.44,1.57,1.57,0,0,1,1.11.44,1.42,1.42,0,0,1,.46,1,1.39,1.39,0,0,1-.46,1,1.53,1.53,0,0,1-1.11.44,1.49,1.49,0,0,1-1.1-.44,1.35,1.35,0,0,1-.46-1A1.39,1.39,0,0,1,37.07,38.6Z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyDocsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-docs-icon.6d410e73.svg";
export { ForwardRef as ReactComponent };